export default __webpack_public_path__ + "static/media/dokumentace.b62bb619.png";